"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MapPin, Phone, Mail } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-6 w-32 bg-muted animate-pulse rounded-md" />
        <div className="h-6 w-28 bg-muted animate-pulse rounded-md" />
        <div className="h-6 w-36 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="text-white hover:text-primary px-0 hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent h-auto py-1 text-sm font-default font-normal">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function InformationFooter() {
  return <section data-section-id="228766" id="footer" className="bg-[#000000] border-t border-gray-800 py-12 md:py-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage">
              <img src="https://causal-crawfish.10web.cloud/wp-content/uploads/2026/05/klassentrtmnt.png" className="object-contain brightness-0 invert !w-[50px] !h-[50px]" alt="Atlantis Holding" />
            </Link>
            <div className="flex flex-col gap-4 text-white/80">
              <div className="flex items-start gap-3">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm font-default">Sofia, Bulgaria</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-5 text-primary shrink-0" />
                <span className="text-sm font-default">+359 2 321 313</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-5 text-primary shrink-0" />
                <span className="text-sm font-default">klassentertainment@gmail.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default font-semibold text-lg text-white uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/HomePage" className="text-sm text-white/70 hover:text-primary transition-all font-default">
                  Home
                </Link>
              </li>
              <li>
                <Link to="#" className="text-sm text-white/70 hover:text-primary transition-all font-default">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="#" className="text-sm text-white/70 hover:text-primary transition-all font-default">
                  Partners
                </Link>
              </li>
              <li>
                <Link to="#" className="text-sm text-white/70 hover:text-primary transition-all font-default">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default font-semibold text-lg text-white uppercase tracking-wider">
              Legal
            </h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
            <p className="text-[14px] text-white/60 font-default mt-4">© 2025 Klass Entertainmnet</p>
          </div>

        </div>
      </div>
    </section>;
}